import { Check, Close } from "@mui/icons-material";
import {
  Grid2 as Grid,
  Grid2Props as GridProps,
  Typography,
  Link,
} from "@mui/material";
import { ReactNode } from "react";
import { FC } from "react";

export interface ILabeledValueProps {
  label: string;
  value?: ReactNode;
  fallback?: string;
  size?: GridProps["size"];
  isSuccess?: boolean;
  isLink?: boolean;
  linkTarget?: string;
}

const LabeledValue: FC<ILabeledValueProps> = ({
  label,
  value,
  fallback = "-",
  size = { xs: 12, sm: 4, xl: 3 },
  isSuccess,
  isLink = false,
  linkTarget = "#",
}) => {
  let content: ReactNode = fallback;

  if (isSuccess !== undefined) {
    content = isSuccess ? <Check color="success" /> : <Close color="error" />;
  } else if (value) {
    content = value;
  }

  const renderValue = () => {
    if (isLink) {
      return (
        <Link href={linkTarget} target="_blank" rel="noopener noreferrer">
          Открыть
        </Link>
      );
    }

    return content;
  };

  return (
    <Grid size={size}>
      <Typography sx={{ display: "flex", flexDirection: "column" }}>
        <Typography component="span" variant="body2" sx={{ color: "grey.500" }}>
          {label}
        </Typography>
        <Typography component="span">{renderValue()}</Typography>
      </Typography>
    </Grid>
  );
};

export default LabeledValue;
